export const plans = [
  {
    name: 'Starter',
    price: '$9',
    originalPrice: null,
    period: '/mo',
    trialText: '$1 first month',
    afterTrialText: null,
    description: 'Perfect for creators starting their growth journey',
    followerLimit: 'Up to 50k followers',
    gradient: 'from-green-500 to-emerald-500',
    features: [
      '1 TikTok account',
      'Continuous content analysis',
      '3 curated content ideas per day delivered to your inbox',
      'Weekly analytics dashboard',
      'Basic video performance analysis',
    ],
    ctaText: 'Start $1 Trial',
    ctaHref: '/api/billing?plan=starter',
    popular: false,
  },
  {
    name: 'Pro',
    price: '$29',
    originalPrice: null,
    period: '/mo',
    trialText: null,
    afterTrialText: null,
    description: 'Creators ready to grow faster with daily insights',
    followerLimit: 'Up to 500k followers',
    gradient: 'from-orange-500 to-pink-500',
    features: [
      'Everything in Starter',
      '10 curated content ideas per day delivered to your inbox',
      'Daily analytics dashboard',
      'Advanced video performance analysis reports',
      'Customer support',
    ],
    ctaText: 'Go Pro',
    ctaHref: '/api/billing?plan=pro',
    popular: true,
  },
  {
    name: 'Studio',
    price: 'Starting at $149',
    originalPrice: null,
    period: '/mo',
    trialText: null,
    afterTrialText: null,
    description: 'Agencies or full-time creators managing teams',
    followerLimit: 'Unlimited followers',
    gradient: 'from-blue-500 to-indigo-500',
    features: [
      'Everything in Pro',
      'Team collaboration (up to 5 team members)',
      'Exportable reports',
      'Custom Workflows',
      'Priority support',
    ],
    ctaText: 'Contact Us',
    ctaHref: 'mailto:support@ignission.io?subject=Studio%20Plan',
    popular: false,
  },
]; 